import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import ProfileSuggestions from './ProfileSuggestions';
import ProfileFavorites from './ProfileFavorites';


class ProfileProfile extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <span>
        <ProfileSuggestions />
        <br />
      </span>
    );
  }
}


function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps, { push })(ProfileProfile);



// WEBPACK FOOTER //
// ./src/containers/ProfileProfile.jsx